import { useState } from 'react';
import SEO from '../components/SEO';
import '../styles/franchise-inquiry.css';

function FranchiseInquiry() {
  const [formData, setFormData] = useState({
    name: '',
    phone: ['', '', ''],
    region1: '',
    region2: '',
    hasStore: '',
    storeSize: '',
    source: '',
    content: '',
    agree: false
  });
  const [popup, setPopup] = useState({ show: false, type: '', message: '' });

  const regions = {
    '서울특별시': ['강남구', '강동구', '강북구', '강서구', '관악구', '광진구', '구로구', '금천구', '노원구', '도봉구', '동대문구', '동작구', '마포구', '서대문구', '서초구', '성동구', '성북구', '송파구', '양천구', '영등포구', '용산구', '은평구', '종로구', '중구', '중랑구'],
    '부산광역시': ['강서구', '금정구', '기장군', '남구', '동구', '동래구', '부산진구', '북구', '사상구', '사하구', '서구', '수영구', '연제구', '영도구', '중구', '해운대구'],
    '대구광역시': ['남구', '달서구', '달성군', '동구', '북구', '서구', '수성구', '중구'],
    '인천광역시': ['강화군', '계양구', '남동구', '동구', '미추홀구', '부평구', '서구', '연수구', '옹진군', '중구'],
    '광주광역시': ['광산구', '남구', '동구', '북구', '서구'],
    '대전광역시': ['대덕구', '동구', '서구', '유성구', '중구'],
    '울산광역시': ['남구', '동구', '북구', '울주군', '중구'],
    '세종특별자치시': ['세종시'],
    '경기도': ['가평군', '고양시', '과천시', '광명시', '광주시', '구리시', '군포시', '김포시', '남양주시', '동두천시', '부천시', '성남시', '수원시', '시흥시', '안산시', '안성시', '안양시', '양주시', '양평군', '여주시', '연천군', '오산시', '용인시', '의왕시', '의정부시', '이천시', '파주시', '평택시', '포천시', '하남시', '화성시'],
    '강원도': ['강릉시', '고성군', '동해시', '삼척시', '속초시', '양구군', '양양군', '영월군', '원주시', '인제군', '정선군', '철원군', '춘천시', '태백시', '평창군', '홍천군', '화천군', '횡성군'],
    '충청북도': ['괴산군', '단양군', '보은군', '영동군', '옥천군', '음성군', '제천시', '진천군', '청주시', '충주시', '증평군'],
    '충청남도': ['계룡시', '공주시', '금산군', '논산시', '당진시', '보령시', '부여군', '서산시', '서천군', '아산시', '예산군', '천안시', '청양군', '태안군', '홍성군'],
    '전라북도': ['고창군', '군산시', '김제시', '남원시', '무주군', '부안군', '순창군', '완주군', '익산시', '임실군', '장수군', '전주시', '정읍시', '진안군'],
    '전라남도': ['강진군', '고흥군', '곡성군', '광양시', '구례군', '나주시', '담양군', '목포시', '무안군', '보성군', '순천시', '신안군', '여수시', '영광군', '영암군', '완도군', '장성군', '장흥군', '진도군', '함평군', '해남군', '화순군'],
    '경상북도': ['경산시', '경주시', '고령군', '구미시', '군위군', '김천시', '문경시', '봉화군', '상주시', '성주군', '안동시', '영덕군', '영양군', '영주시', '영천시', '예천군', '울릉군', '울진군', '의성군', '청도군', '청송군', '칠곡군', '포항시'],
    '경상남도': ['거제시', '거창군', '고성군', '김해시', '남해군', '밀양시', '사천시', '산청군', '양산시', '의령군', '진주시', '창녕군', '창원시', '통영시', '하동군', '함안군', '함양군', '합천군'],
    '제주특별자치도': ['서귀포시', '제주시']
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name.startsWith('phone')) {
      const index = parseInt(name.split('_')[1]);
      const newPhone = [...formData.phone];
      newPhone[index] = value;
      setFormData(prev => ({ ...prev, phone: newPhone }));
    } else if (type === 'checkbox') {
      setFormData(prev => ({ ...prev, [name]: checked }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
      if (name === 'region1') {
        setFormData(prev => ({ ...prev, region2: '' }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.phone.every(p => p) || !formData.region1 || !formData.hasStore || !formData.source || !formData.agree) {
      alert('필수 항목을 모두 입력해주세요.');
      return;
    }

    setPopup({ show: true, type: 'loading', message: '가맹문의를 전송하고 있습니다...' });

    const requestData = {
      name: formData.name,
      phone: formData.phone.join('-'),
      region: `${formData.region1} ${formData.region2}`.trim(),
      hasStore: formData.hasStore,
      storeSize: formData.storeSize,
      source: formData.source,
      content: formData.content
    };

    try {
      const response = await fetch('https://koreakookmingold.com/api/franchise-inquiry', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestData)
      });

      if (response.ok) {
        setPopup({ show: true, type: 'success', message: '가맹문의가 접수되었습니다.\n빠른 시일 내에 연락드리겠습니다.' });
        setFormData({
          name: '',
          phone: ['', '', ''],
          region1: '',
          region2: '',
          hasStore: '',
          storeSize: '',
          source: '',
          content: '',
          agree: false
        });
      } else {
        setPopup({ show: true, type: 'error', message: '문의 접수 중 오류가 발생했습니다.\n다시 시도해주세요.' });
      }
    } catch (error) {
      console.error('Error:', error);
      setPopup({ show: true, type: 'error', message: '문의 접수 중 오류가 발생했습니다.\n다시 시도해주세요.' });
    }
  };

  return (
    <>
      <SEO 
        title="가맹문의 - 한국국민금거래소"
        description="한국국민금거래소 가맹점 개설 문의. 안정적인 수익구조와 전문적인 교육시스템으로 성공적인 창업을 지원합니다"
        keywords="한국국민금거래소 가맹, 금거래소 창업, 금거래소 가맹비용, 금거래소 가맹문의, 금거래소 가맹점, 한국국민금거래소"
        url="https://koreakookmingold.com/franchise"
      />
      <main className="franchise-inquiry">
      <section className="franchise-inquiry__hero franchise-inquiry__section">
        <div className="franchise-inquiry__hero-content">
          <h1 className="franchise-inquiry__hero-title">가맹문의</h1>
          <p className="franchise-inquiry__hero-subtitle">
            한국국민금거래소와 함께<br className="mobile-break" />
            성공적인 사업을 시작하세요
          </p>
        </div>
      </section>

      <section className="franchise-inquiry__form-section franchise-inquiry__section">
        <div className="container">
          <div className="franchise-inquiry__form-header">
            <h2 className="franchise-inquiry__form-title">가맹 문의 신청</h2>
            <p className="franchise-inquiry__form-subtitle">
              정확한 정보를 작성해주시면<br className="mobile-break" />
              보다 빠른 상담이 가능합니다
            </p>
          </div>

          <form className="franchise-inquiry__form" onSubmit={handleSubmit}>
            <div className="franchise-inquiry__form-fields">
              <div className="franchise-inquiry__form-field">
                <label className="franchise-inquiry__field-label">성명 <span className="required">*</span></label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="franchise-inquiry__field-input"
                  placeholder="성명을 입력해주세요"
                />
              </div>
              
              <div className="franchise-inquiry__form-field">
                <label className="franchise-inquiry__field-label">연락처 <span className="required">*</span></label>
                <div className="franchise-inquiry__phone-inputs">
                  <input
                    type="tel"
                    name="phone_0"
                    value={formData.phone[0]}
                    onChange={handleInputChange}
                    maxLength="3"
                    className="franchise-inquiry__phone-input"
                    placeholder="010"
                  />
                  <span>-</span>
                  <input
                    type="tel"
                    name="phone_1"
                    value={formData.phone[1]}
                    onChange={handleInputChange}
                    maxLength="4"
                    className="franchise-inquiry__phone-input"
                    placeholder="1234"
                  />
                  <span>-</span>
                  <input
                    type="tel"
                    name="phone_2"
                    value={formData.phone[2]}
                    onChange={handleInputChange}
                    maxLength="4"
                    className="franchise-inquiry__phone-input"
                    placeholder="5678"
                  />
                </div>
              </div>

              <div className="franchise-inquiry__form-field">
                <label className="franchise-inquiry__field-label">창업 희망 지역 <span className="required">*</span></label>
                <div className="franchise-inquiry__region-selects">
                  <select
                    name="region1"
                    value={formData.region1}
                    onChange={handleInputChange}
                    required
                    className="franchise-inquiry__field-input"
                  >
                    <option value="">시/도 선택</option>
                    {Object.keys(regions).map(region => (
                      <option key={region} value={region}>{region}</option>
                    ))}
                  </select>
                  
                  <select
                    name="region2"
                    value={formData.region2}
                    onChange={handleInputChange}
                    className="franchise-inquiry__field-input"
                    disabled={!formData.region1}
                  >
                    <option value="">구/군 선택</option>
                    {formData.region1 && regions[formData.region1]?.map(district => (
                      <option key={district} value={district}>{district}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="franchise-inquiry__form-field">
                <label className="franchise-inquiry__field-label">상가유무 <span className="required">*</span></label>
                <div className="franchise-inquiry__radio-group">
                  <label className="franchise-inquiry__radio-label">
                    <input
                      type="radio"
                      name="hasStore"
                      value="유"
                      checked={formData.hasStore === '유'}
                      onChange={handleInputChange}
                    />
                    <span>유</span>
                  </label>
                  <label className="franchise-inquiry__radio-label">
                    <input
                      type="radio"
                      name="hasStore"
                      value="무"
                      checked={formData.hasStore === '무'}
                      onChange={handleInputChange}
                    />
                    <span>무</span>
                  </label>
                </div>
              </div>

              <div className="franchise-inquiry__form-field">
                <label className="franchise-inquiry__field-label">상가면적(평)</label>
                <input
                  type="text"
                  name="storeSize"
                  value={formData.storeSize}
                  onChange={handleInputChange}
                  className="franchise-inquiry__field-input"
                  placeholder="예: 20평 (선택사항)"
                />
              </div>

              <div className="franchise-inquiry__form-field">
                <label className="franchise-inquiry__field-label">유입경로 <span className="required">*</span></label>
                <select
                  name="source"
                  value={formData.source}
                  onChange={handleInputChange}
                  required
                  className="franchise-inquiry__field-input"
                >
                  <option value="">선택</option>
                  <option value="인터넷 검색">인터넷 검색</option>
                  <option value="블로그">블로그</option>
                  <option value="유튜브">유튜브</option>
                  <option value="인스타그램">인스타그램</option>
                  <option value="지인소개">지인소개</option>
                  <option value="점주소개">점주소개</option>
                  <option value="기타">기타</option>
                </select>
              </div>

              <div className="franchise-inquiry__form-field">
                <label className="franchise-inquiry__field-label">문의내용</label>
                <textarea
                  name="content"
                  value={formData.content}
                  onChange={handleInputChange}
                  rows="6"
                  className="franchise-inquiry__field-input textarea"
                  placeholder="가맹점 개설에 대한 궁금한 사항이나 문의사항을 자유롭게 작성해주세요. (예: 초기 투자비용, 예상 매출, 교육 기간 등)"
                />
              </div>
            </div>

            <div className="franchise-inquiry__form-field franchise-inquiry__agreement-field">
              <label className="franchise-inquiry__agreement-label">
                <input
                  type="checkbox"
                  name="agree"
                  checked={formData.agree}
                  onChange={handleInputChange}
                  required
                />
                <span>개인정보 수집 및 이용에 동의합니다 <span className="required">*</span></span>
              </label>
              <div className="franchise-inquiry__agreement-text">
                <strong>[개인정보처리방침]</strong><br/><br/>
                한국국민금거래소(이하 "회사")는 이용자의 개인정보를 중요시하며, 「개인정보 보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법령을 준수하고 있습니다.<br/><br/>
                
                <strong>제1조 (수집하는 개인정보 항목 및 수집 방법)</strong><br/>
                회사는 다음과 같은 개인정보를 수집하고 있습니다.<br/>
                - 가맹문의 시: 이름, 연락처, 희망지역, 상가정보, 유입경로, 문의내용<br/><br/>
                
                <strong>제2조 (개인정보의 수집 및 이용 목적)</strong><br/>
                회사는 수집한 개인정보를 다음의 목적을 위해 이용합니다.<br/>
                - 가맹문의 접수 및 상담<br/>
                - 가맹점 개설 관련 정보 제공<br/>
                - 서비스 관련 공지사항 전달<br/><br/>
                
                <strong>제3조 (개인정보의 보유 및 이용 기간)</strong><br/>
                회사는 개인정보 수집 및 이용 목적이 달성된 후에는 지체 없이 해당 정보를 파기합니다.<br/>
                단, 관련 법령에 따라 일정 기간 보존할 수 있습니다.<br/><br/>
                
                <strong>제4조 (개인정보 보호책임자)</strong><br/>
                개인정보 보호책임자: 이종기<br/>
                연락처: 02-409-7800<br/>
                이메일: jglee010@gmail.com
              </div>
            </div>

            <div className="franchise-inquiry__form-submit">
              <button type="submit" className="franchise-inquiry__submit-button">
                가맹문의 신청하기
              </button>
            </div>
          </form>
        </div>
      </section>

      {popup.show && (
        <div className="loading-popup" onClick={() => popup.type !== 'loading' && setPopup({ show: false, type: '', message: '' })}>
          <div className="loading-popup__content" onClick={(e) => e.stopPropagation()}>
            {popup.type === 'loading' && <div className="loading-spinner"></div>}
            {popup.type === 'success' && (
              <svg className="popup-icon success" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#4CAF50" strokeWidth="2"/>
                <path d="M8 12l2 2 4-4" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
            {popup.type === 'error' && (
              <svg className="popup-icon error" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#f44336" strokeWidth="2"/>
                <path d="M15 9l-6 6M9 9l6 6" stroke="#f44336" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            )}
            <p>{popup.message}</p>
            {popup.type !== 'loading' && (
              <button className="popup-close-btn" onClick={() => setPopup({ show: false, type: '', message: '' })}>확인</button>
            )}
          </div>
        </div>
      )}

      <section className="franchise-inquiry__benefits franchise-inquiry__section">
        <div className="container">
          <div className="franchise-inquiry__benefits-header">
            <h2 className="franchise-inquiry__benefits-title">한국국민금거래소<br className="mobile-break" /> 선택 이유</h2>
          </div>
          
          <div className="franchise-inquiry__benefits-grid">
            <div className="franchise-inquiry__benefit-item">
              <div className="franchise-inquiry__benefit-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="#FFD700"/>
                </svg>
              </div>
              <h3 className="franchise-inquiry__benefit-title">안정적인 수익구조</h3>
              <p className="franchise-inquiry__benefit-desc">
                축적된 노하우와<br/>
                검증된 사업모델로<br/>
                안정적인 수익 보장
              </p>
            </div>

            <div className="franchise-inquiry__benefit-item">
              <div className="franchise-inquiry__benefit-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="franchise-inquiry__benefit-title">전문적인 교육시스템</h3>
              <p className="franchise-inquiry__benefit-desc">
                금거래 전문 지식부터<br/>
                매장 운영까지<br/>
                체계적인 교육 지원
              </p>
            </div>

            <div className="franchise-inquiry__benefit-item">
              <div className="franchise-inquiry__benefit-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" fill="#FFD700"/>
                </svg>
              </div>
              <h3 className="franchise-inquiry__benefit-title">브랜드 신뢰도</h3>
              <p className="franchise-inquiry__benefit-desc">
                대한민국 최고의<br/>
                금거래 전문기업 브랜드로<br/>
                높은 고객 신뢰도 확보
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="franchise-inquiry__process franchise-inquiry__section">
        <div className="container">
          <div className="franchise-inquiry__process-header">
            <h2 className="franchise-inquiry__process-title">가맹절차</h2>
          </div>
          
          <div className="franchise-inquiry__process-grid">
            <div className="franchise-inquiry__process-item">
              <div className="franchise-inquiry__process-icon">
                <span className="franchise-inquiry__process-number">01</span>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.2c.27-.27.35-.67.24-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z" fill="#FFD700"/>
                </svg>
              </div>
              <div className="process-content">
                <h3 className="franchise-inquiry__process-content-title">가맹점 문의 및 상담</h3>
                <p className="franchise-inquiry__process-content-desc">홈페이지 또는 전화 문의 후<br/>담당자와 상담진행</p>
              </div>
            </div>

            <div className="franchise-inquiry__process-item">
              <div className="franchise-inquiry__process-icon">
                <span className="franchise-inquiry__process-number">02</span>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="#FFD700"/>
                </svg>
              </div>
              <div className="process-content">
                <h3 className="franchise-inquiry__process-content-title">상권분석</h3>
                <p className="franchise-inquiry__process-content-desc">현장방문 및 지역 상권조사</p>
              </div>
            </div>

            <div className="franchise-inquiry__process-item">
              <div className="franchise-inquiry__process-icon">
                <span className="franchise-inquiry__process-number">03</span>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 2 2h7l5-5V4c0-1.1-.9-2-2-2zm4 15l-4 4H6V4h8v11z" fill="#FFD700"/>
                  <path d="M8 6h6v2H8zm0 3h6v2H8zm0 3h4v2H8z" fill="#FFD700"/>
                </svg>
              </div>
              <div className="process-content">
                <h3 className="franchise-inquiry__process-content-title">가맹점 계약</h3>
                <p className="franchise-inquiry__process-content-desc">최종협의 및 계약체결<br/>가맹계약서, 계약금 지불</p>
              </div>
            </div>

            <div className="franchise-inquiry__process-item">
              <div className="franchise-inquiry__process-icon">
                <span className="franchise-inquiry__process-number">04</span>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L2 7l10 5 10-5-10-5z" fill="#FFD700"/>
                  <path d="M2 17l10 5 10-5" fill="none" stroke="#FFD700" stroke-width="2"/>
                  <path d="M2 12l10 5 10-5" fill="none" stroke="#FFD700" stroke-width="2"/>
                </svg>
              </div>
              <div className="process-content">
                <h3 className="franchise-inquiry__process-content-title">매장 설계 및 준비</h3>
                <p className="franchise-inquiry__process-content-desc">매장 실측 및 도면설계</p>
              </div>
            </div>

            <div className="franchise-inquiry__process-item">
              <div className="franchise-inquiry__process-icon">
                <span className="franchise-inquiry__process-number">05</span>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="process-content">
                <h3 className="franchise-inquiry__process-content-title">직원채용 및 교육진행</h3>
                <p className="franchise-inquiry__process-content-desc">금거래 전문 직원 채용<br/>현장실습 및 본사이론 교육 진행</p>
              </div>
            </div>

            <div className="franchise-inquiry__process-item">
              <div className="franchise-inquiry__process-icon">
                <span className="franchise-inquiry__process-number">06</span>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" fill="#FFD700"/>
                </svg>
              </div>
              <div className="process-content">
                <h3 className="franchise-inquiry__process-content-title">매장 완공 및 오픈 준비</h3>
                <p className="franchise-inquiry__process-content-desc">현장시공 감리<br/>금고, 보안시설 세팅</p>
              </div>
            </div>

            <div className="franchise-inquiry__process-item">
              <div className="franchise-inquiry__process-icon">
                <span className="franchise-inquiry__process-number">07</span>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="#FFD700"/>
                  <circle cx="12" cy="12" r="10" fill="none" stroke="#FFD700" stroke-width="2"/>
                </svg>
              </div>
              <div className="process-content">
                <h3 className="franchise-inquiry__process-content-title">최종점검 및 오픈</h3>
                <p className="franchise-inquiry__process-content-desc">초도물품 검수<br/>최종점검 및 오픈 시뮬레이션</p>
              </div>
            </div>

            <div className="franchise-inquiry__process-item franchise-inquiry__process-item--final">
              <div className="franchise-inquiry__process-icon">
                <span className="franchise-inquiry__process-number">08</span>
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="white"/>
                </svg>
              </div>
              <div className="process-content">
                <h2 className="franchise-inquiry__process-content-main">GRAND OPEN</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
}

export default FranchiseInquiry;